<template>
  <div>
    <v-row>
      <v-col cols="12" md="3">
        <NavigationComponent />
      </v-col>
      <v-col cols="12" md="9">
        <v-sheet color="white" class="pa-5" rounded>
          <h3>اطلاعات کاربری</h3>
          <v-form v-model="valid" @submit.prevent="handleUpdateUser">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="نام کاربری - تلفن همراه"
                  :value="username"
                  hide-details="auto"
                  disabled
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  label="نام"
                  v-model="firstname"
                  :rules="firstnameRules"
                  hide-details="auto"
                  required
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  label="نام خانوادگی"
                  v-model="lastname"
                  :rules="lastnameRules"
                  hide-details="auto"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="نام مدرسه"
                  v-model="school"
                  :rules="schoolRules"
                  hide-details="auto"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  dense
                  :items="stateItems"
                  v-model="state"
                  :rules="stateRules"
                  item-text="name"
                  item-value="_id"
                  label="استان"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  dense
                  :items="cityItems"
                  v-model="city"
                  :rules="cityRules"
                  item-text="name"
                  item-value="_id"
                  label="شهر"
                  required
                />
              </v-col>
            </v-row>
            <v-btn
              :loading="loading"
              :disabled="loading || !valid"
              depressed
              block
              color="primary"
              type="submit"
              class="flex-grow-1"
            >
              ویرایش اطلاعات
            </v-btn>
          </v-form>
        </v-sheet>

        <v-sheet color="white" class="mt-5 pa-5" rounded>
          <h3>تغییر کلمه عبور</h3>
          <v-form @submit.prevent="handleChangePass">
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  dense
                  v-model="oldPassword"
                  label="کلمه عبور فعلی"
                  type="password"
                  required
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  dense
                  v-model="password"
                  label="کلمه عبور جدید"
                  :rules="passwordRules"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                  hint="پسورد می بایست حداقل از 6 حرف تشکیل شده باشد"
                  counter
                  required
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  dense
                  v-model="confirmPass"
                  label="تکرار کلمه عبور"
                  :rules="confirmPassRules.concat(passwordConfirmationRule)"
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show2 ? 'text' : 'password'"
                  @click:append="show2 = !show2"
                  hint="پسورد می بایست حداقل از 6 حرف تشکیل شده باشد"
                  counter
                  required
                />
              </v-col>
            </v-row>
            <v-btn
              :loading="loading"
              depressed
              block
              color="error"
              type="submit"
              class="flex-grow-1"
            >
              تغییر کلمه عبور
            </v-btn>
          </v-form>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NavigationComponent from "./_Navigation.vue";
import { mapGetters } from "vuex";

export default {
  name: "profile-component",
  components: {
    NavigationComponent
  },
  data: () => {
    return {
      loading: false,
      valid: true,
      username: "",
      firstname: "",
      firstnameRules: [(v) => !!v || "استان خود را انتخاب نمایید"],
      lastname: "",
      lastnameRules: [(v) => !!v || "استان خود را انتخاب نمایید"],
      school: "",
      schoolRules: [(v) => !!v || "نام مدرسه خود را وارد نمایید"],
      state: "",
      stateRules: [(v) => !!v || "استان خود را انتخاب نمایید"],
      stateItems: [],
      city: "",
      cityRules: [(v) => !!v || "شهر خود را انتخاب نمایید"],
      cityItems: [],
      oldPassword: "",
      password: "",
      passwordRules: [(v) => !!v || "کلمه عبور خود را وارد نمایید"],
      confirmPass: "",
      confirmPassRules: [(v) => !!v || "تکرار کلمه عبور خود را وارد نمایید"],
      show1: false,
      show2: false
    };
  },
  watch: {
    state(val) {
      this.handleGetCity(val);
    }
  },
  computed: {
    ...mapGetters(["user"]),
    passwordConfirmationRule() {
      return () => this.password === this.confirmPass || "پسور یکسان نیست";
    }
  },
  mounted() {
    this.handleGetStates();
    this.handleGetUser();
  },
  methods: {
    handleGetUser() {
      this.$api.get("/user/checkToken").then((res) => {
        const user = res.data.user;
        this.username = user.username;
        this.firstname = user.firstname;
        this.lastname = user.lastname;
        this.school = user.school;
        this.state = user.city.state;
        this.city = user.city._id;
        this.handleGetCity(user.city._id);
      });
    },
    handleUpdateUser() {
      this.$api
        .patch("/user/update", {
          firstname: this.firstname,
          lastname: this.lastname,
          school: this.school,
          city: this.city
        })
        .then(() => {
          this.$store.commit("clearMessageState");
          this.$store.commit("setMessageState");
          this.$store.commit("setMessageType", "success");
          this.$store.commit(
            "setMessage",
            "اطلاعات شما به موفقیت به‌روزرسانی شد"
          );
        });
    },
    handleChangePass() {
      this.$api
        .post("/user/changePassword", {
          oldPassword: this.oldPassword,
          newPassword: this.password
        })
        .then(() => {
          this.$store.commit("clearMessageState");
          this.$store.commit("setMessageState");
          this.$store.commit("setMessageType", "success");
          this.$store.commit(
            "setMessage",
            "اطلاعات شما به موفقیت به‌روزرسانی شد"
          );
        })
        .catch((err) => {
          this.$store.commit("clearMessageState");
          this.$store.commit("setMessageState");
          this.$store.commit("setMessageType", "error");
          this.$store.commit("setMessage", err.response.data);
        });
    },
    handleGetStates() {
      this.loading = true;
      this.$api.get("/states").then((res) => {
        this.stateItems = res.data.states;
        this.loading = false;
      });
    },
    handleGetCity(id) {
      this.loading = true;
      this.cityItems = [];
      this.$api.get("/cities/" + id).then((res) => {
        this.cityItems = res.data.cities;
        this.loading = false;
      });
    }
  }
};
</script>
